import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";
import { SidebarService } from "src/app/shared/ui/sidebar/sidebar.service";
import { closeAllPanels, closePanel, openPanel } from "../actions/sidebar.actions";

export const openPanelEffect = createEffect(
  (actions$ = inject(Actions), sidebarService = inject(SidebarService)) =>
    actions$.pipe(
      ofType(openPanel),
      tap(({ panelName }) => sidebarService.openPanel(panelName))
    ),
  { functional: true, dispatch: false }
);

export const closePanelEffect = createEffect(
  (actions$ = inject(Actions), sidebarService = inject(SidebarService)) =>
    actions$.pipe(
      ofType(closePanel, closeAllPanels),
      tap(({ panelName }) => sidebarService.closePanel(panelName))
    ),
  { functional: true, dispatch: false }
);
